"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
;
var Switch = (function (_super) {
    __extends(Switch, _super);
    function Switch(props) {
        return _super.call(this, props) || this;
    }
    Switch.prototype.render = function () {
        var value = this.props.value.toString();
        var placeholder = this.props[value];
        if (placeholder && Array.isArray(placeholder))
            return React.createElement("div", null, placeholder);
        return null;
    };
    return Switch;
}(React.Component));
exports.Switch = Switch;



//////////////////
// WEBPACK FOOTER
// ./src/RenderEngine/SwitchRenderer.tsx
// module id = 58
// module chunks = 0